import { equalDeliveryInfo } from '~/lib/utils/delivery_info';
import { DeliveryBundle, ShippingSpec } from '~/types/resources';
import { DeliveryInfo } from '~/types/resources/deliveryInfo';

export type CalculateBundleAmountsInput = {
  playAmount: number;
  deliveryBundles: DeliveryBundle[];
  deliveryInfo: DeliveryInfo | null;
  shippingSpec: ShippingSpec | undefined;
};

export const calculateBundleAmount = (
  input: CalculateBundleAmountsInput
): number => {
  if (input.deliveryInfo == null) return 0;
  if (input.deliveryInfo.country === undefined) return 0;
  const deliveryBundles = input.deliveryBundles ?? [];

  const deliveryBundle = deliveryBundles?.find((deliveryBundle) => {
    return equalDeliveryInfo(input.deliveryInfo, deliveryBundle.delivery_info);
  });

  const _calcBundleAmount = (input: {
    spec?: ShippingSpec;
    availableBundleAmount: number;
    playAmount: number;
  }): number => {
    const { spec, availableBundleAmount, playAmount } = input;
    if (spec == undefined) return 0;
    if (playAmount == 0) return 0;
    if (spec.bundle_capacity == 0) return playAmount;
    if (availableBundleAmount == 0 && playAmount <= spec.bundle_capacity)
      return 1;
    if (availableBundleAmount == 0)
      return Math.ceil(playAmount / spec.bundle_capacity);
    if (availableBundleAmount >= playAmount) return 0;
    return Math.ceil(
      (playAmount - availableBundleAmount) / spec.bundle_capacity
    );
  };
  return _calcBundleAmount({
    spec: input.shippingSpec,
    availableBundleAmount: deliveryBundle?.available_bundle_amount ?? 0,
    playAmount: input.playAmount,
  });
};
